import { CONTENT_HEADING } from "../../constants";
import Content from "../global/Content";
import { useNavigate,Link } from "react-router-dom";

const AboutArticle = () => {
	const navigate = useNavigate();
	const handleRedirect = (e, path = "/registration") => {
		e.preventDefault();
		window.scroll({ top: 0, behavior: "smooth" });
		navigate(path);
	  };
  const token = localStorage.getItem("usertoken");
	return (
		<>
		<div className="guideLineManu">
			<Content title="Preparing Your Manuscript">
				<p className='pera-text tagp'>
					Please follow the complete <Link to="/mega-journal-formatting-guideline" target="_blank" className="underline blackbold" style={{color: "#366c91"}}>Mega Journal Formatting Guidelines</Link> before submitting.
				</p>
				<p className='pera-text tagp'>
					The principal requirements are:
				</p>
				<ul className="tagul">
					<li className="tagli">Submit the manuscript as a PDF, DOC or DOCX file.</li>
					<li className="tagli">Use Times New Roman with the prescribed font sizes.</li>
					<li className="tagli">Use a single-column layout with single line spacing.</li>
					<li className="tagli">Keep the article title within 20 words.</li>
					<li className="tagli">Provide an abstract of 150–400 words.</li>
					<li className="tagli">Provide Five to Six keywords.</li>
					<li className="tagli">Number all pages consecutively.</li>
					<li className="tagli">Arrange the manuscript sections in the required order.</li>
					<li className="tagli">Use one reference style consistently throughout the manuscript.</li>
				</ul>
				<p className='pera-text tagp'>
					Authors should ensure that the manuscript is complete before beginning submission.
				</p>
			</Content>
			
			<Content title="Authors and Affiliations">
				<p className='pera-text tagp'>
					Enter every author’s name exactly as it should appear in the published article and in indexing services. Once entered names cannot be changed. You will need to restart the submitting process afresh.
				</p>
				<p className='pera-text tagp'>
					Authors must:
				</p>
				<ul className="tagul">
					<li className="tagli">Be listed in the agreed publication order.</li>
					<li className="tagli">Provide accurate institutional affiliations.</li>
					<li className="tagli">Identify the corresponding author.</li>
					<li className="tagli">Include all individuals who have made a substantial scholarly contribution.</li>
					<li className="tagli">Confirm that every listed author has reviewed and approved the manuscript.</li>
					<li className="tagli">Disclose any competing interests.</li>
				</ul>
				<p className='pera-text tagp'>
					The manuscript must be submitted through the account of one of its authors. Third-party submissions are not accepted.
				</p>
				<p className='pera-text tagp'>
					Authors are encouraged to provide their ORCID iDs during submission.
				</p>
			</Content>

			<Content title="Language and Originality Checks">
				<p className='pera-text tagp'>
					Manuscripts must be written in clear academic English. Aakashganga Open uses British English as its default language style.
				</p>
				<p className='pera-text tagp'>
					Before submission, please:
				</p>
				<ul className="tagul">
					<li className="tagli">Run a spelling and grammar check.</li>
					<li className="tagli">Check names, technical terms and references carefully.</li>
					<li className="tagli">Remove profane, discriminatory or inappropriate language.</li>
					<li className="tagli">Ensure that all borrowed words, ideas, data and images are properly attributed.</li>
					<li className="tagli">Check that quotations are enclosed in quotation marks and cited.</li>
					<li className="tagli">Confirm that the manuscript has not been published elsewhere or submitted simultaneously to another journal.</li>
				</ul>
				<p className='pera-text tagp'>
					The platform may conduct automated language, profanity, reference and similarity checks. Clearing these checks does not guarantee acceptance; editorial and peer-review decisions are based on the scholarly quality and integrity of the manuscript.
				</p>
			</Content>
			</div>
		</>
	);
};

export default AboutArticle;
